export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-lepidaid.svg?db44ecc8915d88ba30e1ef00828e77c9";